import type { Promotion } from "../../../api/catalog";

type PromotionTabReglesProps = {
  promotion: Promotion;
  isLocked: boolean;
};

const STACKING_LABELS: Record<string, string> = {
  best_discount_only: "Meilleure promo seulement",
  first_match_by_priority: "Première par priorité",
  stackable_only_if_all_combinable: "Empiler si toutes combinables",
};

export function PromotionTabRegles({ promotion }: PromotionTabReglesProps) {
  const valueLabel =
    promotion.promotion_type === "percentage"
      ? `${promotion.value}%`
      : promotion.promotion_type === "fixed_amount"
      ? `${promotion.value} CAD`
      : `Prix fixe: ${promotion.value} CAD`;

  return (
    <div className="space-y-6">
      <h3 className="text-sm font-semibold text-text">Règles</h3>

      <div className="rounded-md border border-border bg-surface p-4 space-y-4">
        <div>
          <label className="text-xs text-muted">Période</label>
          <div className="mt-1 text-sm text-text">
            {new Date(promotion.start_date).toLocaleString("fr-FR")} →{" "}
            {new Date(promotion.end_date).toLocaleString("fr-FR")}
          </div>
        </div>

        <div>
          <label className="text-xs text-muted">Type & Valeur</label>
          <div className="mt-1 text-sm text-text">
            {promotion.promotion_type === "percentage"
              ? "Pourcentage"
              : promotion.promotion_type === "fixed_amount"
              ? "Montant fixe"
              : "Prix fixe final"}{" "}
            — {valueLabel}
          </div>
        </div>

        <div>
          <label className="text-xs text-muted">Empilement</label>
          <div className="mt-1 text-sm text-text">
            {STACKING_LABELS[promotion.stacking_policy] ?? promotion.stacking_policy}
          </div>
          <div className="mt-1 text-xs text-muted">
            Combinable: {promotion.is_combinable ? "Oui" : "Non"} · Priorité: {promotion.priority}
          </div>
        </div>

        <div>
          <label className="text-xs text-muted">Plancher</label>
          <div className="mt-1 text-sm text-text">
            {promotion.respect_floor_price ? "Respecter le prix plancher" : "Ne pas respecter"}
          </div>
        </div>

        <div>
          <label className="text-xs text-muted">Conditions commerciales</label>
          <div className="mt-1 text-sm text-text space-y-1">
            {promotion.min_purchase_amount != null && promotion.min_purchase_amount > 0 && (
              <div>Montant minimum d'achat: {promotion.min_purchase_amount} CAD</div>
            )}
            {promotion.max_uses != null && (
              <div>Limite globale: {promotion.max_uses} utilisations</div>
            )}
            {promotion.max_uses_per_user != null && (
              <div>Limite par utilisateur: {promotion.max_uses_per_user}</div>
            )}
            {(!promotion.min_purchase_amount || promotion.min_purchase_amount <= 0) &&
              promotion.max_uses == null &&
              promotion.max_uses_per_user == null && (
                <div className="text-muted">Aucune condition</div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}
